// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop, omit } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"
import { devLog } from "@helpers/devLog"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

/** initla state for auth store  */
const initialState = {
  banners: [],
  sales: [],
  items: [],
  deals: [],
  news:[],
  laws:"",
  count: "",
  current: {},
  text_news:{},
  perPageValues: [25, 50, 100, 150, 200],
  itemPerPage: 25,
  itemPerPageItems: 25,
  currentPage: 1,
  currentPageItems: 1,
  filters: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  filtersItems: {
    parent: {
      value: "ALL",
      label: "label_all"
    },
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  message: "",
  keyword: null,
  keyWordItems: null,
  action: globalConst.action.NONE
}

export const prefs = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    setLaws: (s, payload) => {
      return {
        ...s,
        laws: payload
      }
    },

    setDeals: (s, payload) => {
      return {
        ...s,
        deals: payload
      }
    },
    setTextNews: (s, payload) => {
      return {
        ...s,
        text_news: payload
      }
    },
    setBanners: (s, payload) => {
        return {
            ...s,
            banners: payload
        }
    },
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    },
    setNews: (s, payload) => {
      return {
        ...s,
        news: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrentPageItems: (s, payload) => {
      return {
        ...s,
        currentPageItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCount: (s, payload) => {
      return {
        ...s,
        count: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
  
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setItems: (s, payload) => {
      return {
        ...s,
        items: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setSales: (s, payload) => {
      return {
        ...s,
        sales: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeywordItems: (s, payload) => {
      return {
        ...s,
        keyWordItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setSubItemsPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPageItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.prefs],
        (exhibitions, exhibitionsLoading) => {
          return exhibitionsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.prefs],
        (prefs, prefsLoading) => prefsLoading.success
      )
    },
    banners() {
        return createSelector([slice], (prefs) => {
            return prefs.banners
        })
    },
    textNews() {
      return createSelector([slice], (prefs) => {
          return prefs.text_news
      })
    },
    news() {
      return createSelector([slice], (prefs) => {
          return prefs.news
      })
      
  },
  deals() {
    return createSelector([slice], (prefs) => {
        return prefs.deals
    })
  },
  laws() {
    return createSelector([slice], (prefs) => {
        return prefs.laws
    })
  }
 

  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchBanners(type = "home") {
      appLogger.info("fetchBanners", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.FETCH_BANNERS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setBanners([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/banners?type=${type}`
        )

        this.setBanners(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setBanners([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    /**
     * Fetch cars banners specifically
     */
    async fetchCarsBanners(type = "cars") {
      appLogger.info("fetchCarsBanners", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.FETCH_BANNERS)
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/banners?type=${type}`
        )

        this.setBanners(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    async fetchLaws( ) {
      appLogger.info("fetchLaws", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.FETCH_LAWS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setLaws("")
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/laws`
        )

        this.setLaws(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setLaws("")
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    async updateLaws({link}) {
      appLogger.info("updateLaws", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.UPDATE_LAWS)
      try {
        const result = await API.post(
          "adminsApi",
          `/prefs/v1/laws`,
          {
            body:{link}
          }
        )

        this.setMessage("Laws updated successfully")
        // this.setCount(count)
      } catch (error) {
     
        throw new Error(error)
      }
    },

    async fetchTextNews( ) {
      appLogger.info("fetchTextNews", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.FETCH_TEXT_NEWS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setTextNews({})
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/text-news`
        )

        this.setTextNews(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setTextNews({})
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    async updateTextNews(payload) {
      appLogger.info("updateTextNews", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.UPDATE_TEXT_NEWS)
      try {
    await API.post(
          "adminsApi",
          `/prefs/v1/text-news`,
          {
            body:{...payload}
          }
        )

        this.setMessage("Text News updated successfully")

      } catch (error) {
     
        throw new Error(error)
      }
    },

    async deleteBanner(pk) {
      appLogger.info("deleteBanner", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.DELETE_BANNER)
      try {
        const result = await API.del(
          "adminsApi",
          `/prefs/v1/banners/${pk}`
        )

        this.setMessage("Banner deleted successfully")
        // this.setAction(globalConst.action.NONE)
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    async fetchNews() {
      appLogger.info("fetchNews", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.FETCH_NEWS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setNews([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/news`
        )

        this.setNews(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setNews([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    async deleteNews(pk) {
      appLogger.info("deleteNews", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.DELETE_NEWS)
      try {
        const result = await API.del(
          "adminsApi",
          `/prefs/v1/news/${pk}`
        )

        this.setMessage("News deleted successfully")
        //this.setAction(globalConst.action.NONE)
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    async fetchDeals() {
      appLogger.info("fetchDeals", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.FETCH_DEALS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setDeals([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/deals`
        )

        this.setDeals(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setDeals([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    async saveDeal(payload) {
      appLogger.info("saveDeal", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.CREATE_DEAL)
      try {
        const result = await API.post(
          "adminsApi",
          `/prefs/v1/deals`,
          {
            body:{...payload}
          }
        )

        this.setMessage("Deal created successfully")
   
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    async updateDeal(payload) {
      appLogger.info("updateDeal", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.UPDATE_DEAL)
      try {
        await API.put(
          "adminsApi",
          `/prefs/v1/deals/${payload.pk}`,
          {
            body:{...payload}
          }
        )

        this.setMessage("Deal updated successfully")
   
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    async deleteDeals(pk) {
      appLogger.info("deleteDeals", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.DELETE_DEAL)
      try {
        const result = await API.del(
          "adminsApi",
          `/prefs/v1/deals/${pk}`
        )

        this.setMessage("Deal deleted successfully")
   
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    async getDeal(pk) {
      appLogger.info("getDeal", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.GET_DEAL)
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/deals/${pk}`
        )

        this.setCurrent(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    /**
     * 
     */
    async getBanner(pk) {
      appLogger.info("getBanner", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.GET_BANNER)
      try {
        const result = await API.get(
          "adminsApi",
          `/prefs/v1/banners/${pk}`
        )

        this.setCurrent(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     * @param {*} payload 
     */
    async saveBanner(payload) {
      appLogger.info("saveBanner", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.CREATE_BANNER)
      try {

         await API.post(
          "adminsApi",
          `/prefs/v1/banners`,
          {
            body:{...payload}
          }
        )

        this.setMessage("Banner created successfully")

      } catch (error) {
        
        throw new Error(error)
      } finally {
        this.setAction(globalConst.action.NONE)
      }
    },

    async saveNews(payload) {
      appLogger.info("saveNews", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.CREATE_NEWS)
      try {
     

         await API.post(
          "adminsApi",
          `/prefs/v1/news`,
          {
            body:{...payload}
          }
        )

        this.setMessage("Article created successfully")

      } catch (error) {
        
        throw new Error(error)
      }
    },
    async updateNews(payload) {
      appLogger.info("updateNews", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.UPDATE_NEWS)
      try {

        const p= new Promise((resolve, reject) => { 
          setTimeout(() => {
            resolve("success")
          }, 1000);
         })
      
         await API.put(
          "adminsApi",
          `/prefs/v1/news/${payload.pk}`,
          {
            body:omit(payload, ["pk"])
          }
        )

        this.setMessage("Article updated successfully")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

     async DeleteNewsModal(pk) {
      appLogger.info("deleteNews", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.DELETE_NEWS)
      try {
        const result = await API.del(
          "adminsApi",
          `/prefs/v1/news/${pk}`
        )

        this.setMessage("News deleted successfully")
   
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     * @param {*} payload 
     */
    async updateBanner(payload) {
      appLogger.info("updateBanner", `[REDUX][${STORES.PREFS}]`)
      this.setAction(globalConst.action.UPDATE_BANNER)
      try {

        const p= new Promise((resolve, reject) => { 
          setTimeout(() => {
            resolve("success")
          }, 1000);
         })
      
         await API.put(
          "adminsApi",
          `/prefs/v1/banners/${payload.pk}`,
          {
            body:omit(payload, ["pk"])
          }
        )

        this.setMessage("Banner updated successfully")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },


    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onSubItemPerPageChange(payload) {
      this.setSubItemsPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      this.setCurrentPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemsCurrentPageChange(payload) {
      this.setCurrentPageItems(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemKeywordChanges(payload) {
      this.setKeywordItems(payload)
    }
  })
}
